module.exports = __webpack_public_path__ + "img/title_no.58918c97.svg";